import React, { useEffect, useRef, useState } from "react";
import TextInput from "../../componets/TextInput";
import { Dialog } from "primereact/dialog";
import { TabPanel, TabView } from "primereact/tabview";
import { Button } from "primereact/button";
import { Message } from "primereact/message";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import { Toast } from "primereact/toast";
import { userGroupsService } from "../../services/UserGroupsService";
import { authenticationService } from "../../services/AuthenticationService";
import { lookupsService } from "../../services/LookupsService";
import { formatDateTime } from "../../config/Config";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";

export const EditUserGroup = ({ group, visible, onHide, onSaveGroup }) => {
	const [form, setForm] = useState(null);

	const [modules, setModules] = useState([]);
	const [modulesAudit, setModulesAudit] = useState([]);
	const [error, setError] = useState("");
	const [loading, setLoading] = useState(false);
	const [editingRows, setEditingRows] = useState({});
	const [selectedModules, setSelectedModules] = useState(null);
	const [moduleOptions, setModuleOptions] = useState([]);
	const [actionOptions, setActionOptions] = useState([]);
	const [hasChanges, setHasChanges] = useState(false);
	const toast = useRef(null);
	const tableRef = useRef(null);

	useEffect(() => {
		lookupsService
			.getByName("action,module")
			.then((data) => {
				setActionOptions(data.actions);
				setModuleOptions(data.modules);
			})
			.catch((error) => {
				console.error("Error fetching lookups:", error);
			});
	}, []);
	
	useEffect(() => {
		setForm({ ...group });
		setModules(group.modules);
		
		userGroupsService
		.getModulesAuditByID(group.groupID)
		.then((data) => {
			setModulesAudit(data);
		})
		.catch((error) => {
			console.error("Error fetching modules audits:", error);
		});
	}, [group]);
	
	const moduleTemplate = (rowData) => {
		const module = moduleOptions.find((mod) => mod.id === rowData.moduleID);
		return module ? module.name : "";
	};
	
	const actionTemplate = (rowData) => {
		return rowData.actions.map((action) => action.name).join(", ");
	};
	
	const moduleEditorTemplate = (options) => {
		const usedModuleIDs = modules.map((module) => module.moduleID);
		const availableModules = moduleOptions.filter((module) => !usedModuleIDs.includes(module.id) || module.id === options.value);
		
		return (
			<Dropdown
			value={options.value}
			options={availableModules}
			onChange={(e) => options.editorCallback(e.value)}
			optionLabel="name"
			optionValue="id"
			placeholder="Select Module"
			/>
		);
	};
	
	const actionEditorTemplate = (options) => {
		const selectedActionIDs = options.value.map((action) => action.actionID);
		
		// const handleActionsChange = (e) => {
			// 	const selectedActions = actionOptions.filter((action) => e.value.includes(action.id));
			// 	options.editorCallback(selectedActions); // Pass the selected actions to update the row data
			// };
			
			const handleActionsChange = (e) => {
				// Map `id`s back to `actionID`s for consistency with the database model
				const selectedActions = actionOptions
				.filter((action) => e.value.includes(action.id))
				.map((action) => ({ actionID: action.id, name: action.name }));
				options.editorCallback(selectedActions);
			};
			
			return (
				<MultiSelect
				value={selectedActionIDs}
				options={actionOptions}
				onChange={handleActionsChange}
				optionLabel="name"
				optionValue="id"
				placeholder="Select Actions"
				display="chip"
				/>
			);
		};
		// useEffect(()=>{
		// 	setHasChanges(true);
		// }, [form.name]);
		const confirmDeleteDelimitation = () => {
		if(hasChanges)
		{
			confirmDialog({
				message: "Unsaved changes will be discarded. Continue?",
				header: "Discard changes?",
				icon: "pi pi-exclamation-triangle",
				accept: () => onClose(),
				reject: () => {}
			});
		}
		else
		{
			onClose();
		}
	};
		
		const addModule = () => {
			// Get the list of module IDs that are already in use
			const usedModuleIDs = modules.map((module) => module.moduleID);
			
			// Filter module options to get available modules
			const availableModules = moduleOptions.filter((module) => !usedModuleIDs.includes(module.id));
			
			if (availableModules.length > 0) {
				 setHasChanges(true);
				const newModule = {
				moduleID: availableModules[0].id, // Default to the first available module
				actions: []
			};

			const updatedModules = [...modules, newModule];

			setModules(updatedModules);

			// Add the new row to editingRows
			const newEditingRows = { ...editingRows, [updatedModules.length - 1]: true };
			setEditingRows(newEditingRows); // Set the row to be in edit mode
		} else {
			setError("All modules are already added.");
		}
	};

	const onRowEditChange = (e) => {
		setEditingRows(e.data);
	};

	const onRowEditComplete = (e) => {
		const { newData, index } = e;
		let updatedModules = [...modules];
		updatedModules[index] = newData;
		setModules(updatedModules);
		 setHasChanges(true);
	};

	const onClose = () => {
		setForm(null);
		setEditingRows({});
		setError("");
		setModules([]);
		onHide();
		 setHasChanges(false);
	};

	const deleteSelectedRows = () => {
		if (selectedModules && selectedModules.length > 0) {
			 setHasChanges(true);
			const updatedModules = modules.filter((module) => !selectedModules.includes(module));
			setModules(updatedModules);
			setSelectedModules(null); // Clear selection after delete
		}
	};

	const save = async () => {
		setLoading(true);
		setError("");

		const data = {
			GroupID: form.groupID,
			Name: form.name,
			Description: form.description,
			UpdatedBy: authenticationService.User.userID,
			Modules: modules
		};

		try {
			var response = await userGroupsService.update(data);

			setLoading(false);

			if (response.success) {
				setForm(null);
				setEditingRows({});
				setError("");
				setModules([]);
				onSaveGroup();

				return toast.current.show({
					severity: "success",
					summary: "Success Message",
					detail: "User group updated successfully",
					life: 1500
				});
			} else {
				setError(response.message);
			}
		} catch (error) {
			setLoading(false);
			setError("Remote server error occured. Please try again or consult your system adminstrator.");
		}
	};
	
	return (
		<div>
			<Toast ref={toast} />
			<Dialog
				draggable={false}
				header={
					<>
						<span>Group - {group?.name}</span>
					</>
				}
				visible={visible}
				onHide={confirmDeleteDelimitation}
				onShow={() => {}}
				style={{ width: "60%", height: "80%" }}
				footer={
					<div>
						<Button icon="pi pi-check" loading={loading} label="Save" onClick={save} className="mt-4 p-button-primary" />
						<Button icon="pi pi-times-circle" label="Cancel" onClick={confirmDeleteDelimitation} className="p-button-danger" />
					</div>
				}
			>
				<TabView>
					<TabPanel header="Details">
						<div className="grid">
							<div className="col-12  lg:col-12">
								<TextInput label="Name" value={form?.name} onChange={(e) => {setHasChanges(true);setForm({ ...form, name: e.target.value })}} />
							</div>

							<div className="col-12 lg:col-12">
								<TextInput
									value={form?.description}
									onChange={(e) =>{setHasChanges(true); setForm({ ...form, description: e.target.value })}}
									label="Description"
								/>
							</div>
						</div>
					</TabPanel>
					<TabPanel header="Modules">
						<Button
							icon="pi pi-plus"
							type="small"
							onClick={addModule}
							className="mb-4 mr-2"
							tooltip="Add Module"
							tooltipOptions={{ position: "top" }}
						/>
						<Button
							icon="pi pi-trash"
							type="small"
							onClick={deleteSelectedRows}
							className="p-button-danger mb-4"
							disabled={!selectedModules || selectedModules.length === 0}
							tooltip="Delete Selected"
							tooltipOptions={{ position: "top" }}
						/>
						<DataTable
							ref={tableRef}
							size="small"
							value={modules}
							editMode="row"
							dataKey="moduleID"
							onRowEditComplete={onRowEditComplete}
							onRowEditChange={onRowEditChange}
							editingRows={editingRows}
							selection={selectedModules}
							onSelectionChange={(e) => setSelectedModules(e.value)}
							selectionMode="checkbox"
						>
							<Column selectionMode="multiple" headerStyle={{ width: "3rem" }} />

							<Column field="moduleID" header="Module Name" body={moduleTemplate} editor={moduleEditorTemplate} />

							<Column field="actions" header="Actions" body={actionTemplate} editor={actionEditorTemplate} />

							<Column rowEditor headerStyle={{ width: "10%", minWidth: "8rem" }} bodyStyle={{ textAlign: "center" }} />
						</DataTable>
					</TabPanel>
					{/* <TabPanel header="Modules History">
						<DataTable size="small" value={modulesAudit} paginator rows={10} rowsPerPageOptions={[5, 10, 25]}>
							<Column field="moduleName" header="Module Name" />
							<Column field="actions" header="Permissions" body={(e) => e.actions.map((action) => action.name).join(", ")} />
							<Column field="auditDate" header="Effective Date" body={(e) => formatDateTime(e.auditDate)} />
							<Column field="createdBy" header="Created By" />
							<Column field="updatedBy" header="Updated By" />
						</DataTable>
					</TabPanel> */}
				</TabView>
				{error && <Message severity="error" text={error} style={{ marginTop: "0.5em" }} />}
			</Dialog>
		</div>
	);
};
